import { useTranslation } from "react-i18next";
import "../scss/publicOffer.scss";

export const PublicOffer = () => {
    const { t } = useTranslation();
    
    return (
        <div className="public-offer">
            <h1>{t('publicOffer.hero.title')}</h1>
            <div className="subtitle">{t('publicOffer.hero.subtitle')}</div>
            <ol>
                {/* 1 */}
                <li>
                    <h2>{t('publicOffer.content.s1.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s1.1')}</li>
                        <li>{t('publicOffer.content.s1.2')}</li>
                        <li>{t('publicOffer.content.s1.3')}</li>
                    </ol>
                </li>
                {/* 2 */}
                <li>
                    <h2>{t('publicOffer.content.s2.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s2.1')}</li>
                        <li>{t('publicOffer.content.s2.2')}</li>
                        <li>{t('publicOffer.content.s2.3')}</li>
                        <li>{t('publicOffer.content.s2.4')}</li>
                        <li>{t('publicOffer.content.s2.5')}</li>
                    </ol>
                </li>
                {/* 3 */}
                <li>
                    <h2>{t('publicOffer.content.s3.text')}</h2>
                    <ol>
                        <li>
                            {t('publicOffer.content.s3.1.text')}
                            <ul>
                                <li>{t('publicOffer.content.s3.1.1')}</li>
                                <li>{t('publicOffer.content.s3.1.2')}</li>
                                <li>{t('publicOffer.content.s3.1.3')}</li>
                                <li>{t('publicOffer.content.s3.1.4')}</li>
                                <li>{t('publicOffer.content.s3.1.5')}</li>
                                <li>{t('publicOffer.content.s3.1.6')}</li>
                                <li>{t('publicOffer.content.s3.1.7')}</li>
                                <li>{t('publicOffer.content.s3.1.8')}</li>
                                <li>{t('publicOffer.content.s3.1.9')}</li>
                                <li>{t('publicOffer.content.s3.1.10')}</li>
                                <li>{t('publicOffer.content.s3.1.11')}</li>
                                {/* {t('publicOffer.content.s3.1.list', { returnObjects: true }).map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))} */}
                            </ul>
                        </li>
                        <li>{t('publicOffer.content.s3.2')}</li>
                    </ol>
                </li>
                {/* 4 */}
                <li>
                    <h2>{t('publicOffer.content.s4.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s4.1')}</li>
                        <li>{t('publicOffer.content.s4.2')}</li>
                        <li>{t('publicOffer.content.s4.3')}</li>
                        <li>
                            {t('publicOffer.content.s4.4.text')}
                            <ul>
                                <li>{t('publicOffer.content.s4.4.1')}</li>
                                <li>{t('publicOffer.content.s4.4.2')}</li>
                            </ul>
                        </li>
                        <li>{t('publicOffer.content.s4.5')}</li>
                    </ol>
                </li>
                {/* 5 */}
                <li>
                    <h2>{t('publicOffer.content.s5.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s5.1')}</li>
                        <li>{t('publicOffer.content.s5.2')}</li>
                        <li>{t('publicOffer.content.s5.3')}</li>
                        <li>{t('publicOffer.content.s5.4')}</li>
                    </ol>
                </li>
                {/* 6 */}
                <li>
                    <h2>{t('publicOffer.content.s6.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s6.1')}</li>
                        <li>{t('publicOffer.content.s6.2')}</li>
                        <li>{t('publicOffer.content.s6.3')}</li>
                    </ol>
                </li>
                {/* 7 */}
                <li>
                    <h2>{t('publicOffer.content.s7.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s7.1')}</li>
                        <li>{t('publicOffer.content.s7.2')}</li>
                        <li>{t('publicOffer.content.s7.3')}</li>
                        <li>{t('publicOffer.content.s7.4')}</li>
                    </ol>
                </li>
                {/* 8 */}
                <li>
                    <h2>{t('publicOffer.content.s8.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s8.1')}</li>
                    </ol>
                </li>
                {/* 9 */}
                <li>
                    <h2>{t('publicOffer.content.s9.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s9.1')}</li>
                        <li>{t('publicOffer.content.s9.2')}</li>
                        <li>{t('publicOffer.content.s9.3')}</li>
                        <li>{t('publicOffer.content.s9.4')}</li>
                    </ol>
                </li>
                {/* 10 */}
                <li>
                    <h2>{t('publicOffer.content.s10.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s10.1')}</li>
                        <li>{t('publicOffer.content.s10.2')}</li>
                        <li>{t('publicOffer.content.s10.3')}</li>
                    </ol>
                </li>
                {/* 11 */}
                <li>
                    <h2>{t('publicOffer.content.s11.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s11.1')}</li>
                        <li>{t('publicOffer.content.s11.2')}</li>
                    </ol>
                </li>
                {/* 12 */}
                <li>
                    <h2>{t('publicOffer.content.s12.text')}</h2>
                    <ol>
                        <li>{t('publicOffer.content.s12.1')}</li>
                        <li>{t('publicOffer.content.s12.2')}</li>
                        <li>{t('publicOffer.content.s12.3')}</li>
                    </ol>
                </li>
            </ol>
        </div>
    );
};

